export const handleVerticalTab = (event, { colIndex, rowIndex }, { totalCols, totalRows }, focusNext) => {
  if (event.key !== 'Tab' || event.ctrlKey || event.altKey || event.metaKey) return;

  const isLastCell = !event.shiftKey && colIndex === totalCols - 1 && rowIndex === totalRows - 1;
  const isFirstCell = event.shiftKey && colIndex === 0 && rowIndex === 0;
  if (isLastCell || isFirstCell) {
    return;
  }

  event.preventDefault();

  let nextCol = colIndex;
  let nextRow = rowIndex;

  if (event.shiftKey) {
    if (rowIndex > 0) {
      nextRow--;
    } else {
      nextCol--;
      nextRow = totalRows - 1;
    }
  } else {
    if (rowIndex < totalRows - 1) {
      nextRow++;
    } else {
      nextCol++;
      nextRow = 0;
    }
  }

  focusNext(nextCol, nextRow);
};

export const getLeafColumns = (config) => {
  let leaves = [];
  config.forEach((column) => {
    if (column.children) {
      leaves = [...leaves, ...getLeafColumns(column.children)];
    } else {
      leaves.push(column);
    }
  });
  return leaves;
};
